import { ConversationType, EstimateCreationSource } from "@rebuild/shared";

/**
 * Picks the Reese conversation flavour (see ConversationalAgent.md) from the state of the
 * estimate the conversation is being started against.
 *
 * A follow-up visit is only a follow-up once notes already exist — an estimate with no scope
 * notes is still an original visit, whatever created it.
 */
export const getConversationType = ({
  stopCount,
  creationSource,
  scopeNoteCount,
}: {
  stopCount: number;
  creationSource: string | undefined;
  scopeNoteCount: number;
}): ConversationType => {
  // Resuming the conversation we paused earlier in this same session.
  if (stopCount > 0) {
    return ConversationType.RESUME_WITHIN_SESSION_CONVO;
  }

  if (scopeNoteCount === 0) {
    // Xcelerate already gave us the address and project name, so its first conversation
    // starts from Cat & Class instead.
    return creationSource === EstimateCreationSource.XCELERATE
      ? ConversationType.XCELERATE_CREATED_FIRST_CONVO
      : ConversationType.NEW_PROJECT_CONVO;
  }

  return ConversationType.FOLLOW_UP_VISIT_CONVO;
};
